"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.loading.title': '正在激活您的账户',
    'activate.loading.message': '请稍候，我们正在激活您的账户...',
};
